import Vue from 'vue';
import Template from '../components/pages/signUp/pc/Index.vue';

import { reloadOnPageShow } from '../helper/_initHelper';

reloadOnPageShow();

const app = new Vue({
  render: (h) => h(Template, {}),
});
Vue.prototype.$isSp = false;
app.$mount('#app');
